module.exports = __webpack_public_path__ + "media/img/home/clients-map/hack-d2dfbb8c9c8045b4699d6572a7a0a3ff.svg";